"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupRolesNames = void 0;
var GroupRolesNames;
(function (GroupRolesNames) {
    GroupRolesNames["OWNER"] = "Owner";
    GroupRolesNames["SUPER_ADMIN"] = "Super Admin";
    GroupRolesNames["ASSET_MANAGER"] = "Asset Manager";
    GroupRolesNames["MEMBER"] = "Member";
    GroupRolesNames["GROUP_MANAGER"] = "Group Manager";
    GroupRolesNames["USER_MANAGER"] = "User Manager";
    GroupRolesNames["BOOKING_MANAGER"] = "Booking Manager";
    GroupRolesNames["BOOKING_MANAGER_EXTERNAL"] = "Booking Manager (External)";
    GroupRolesNames["ANALYST"] = "Analyst";
    GroupRolesNames["CAMPAIGN_MANAGER"] = "Campaign Manager";
})(GroupRolesNames = exports.GroupRolesNames || (exports.GroupRolesNames = {}));
//# sourceMappingURL=groupRolesNames.js.map